import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { useEffect } from 'react';

import { refreshRoutineReads } from './use-routine-refresh';

export const useRoutinesUpdatedEvents = () => {
  useEffect(() => {
    const subscription = globalEventBus.on(
      EventNames.ROUTINES_UPDATED,
      refreshRoutineReads
    );

    return () => subscription.unsubscribe();
  }, []);
};
